export default "__VITE_ASSET__C18Hojbi__"